<div class="activity-navigation">
	<div class="task-view-container">
		<div class="navigation-header">
			<h2>{{ 'activity-view_pill-overview' | translate }}</h2>
		</div>
		<nav class="navigation-list-container" [attr.aria-label]="'activity-view_pill-overview' | translate">
			<ul class="navigation-list">
				@for (navigationItem of navigationItems; track navigationItem.name) {
					<li class="navigation-list-item">
						<a
							class="task-item"
							[attr.data-cy]="'activity-nav-item-' + navigationItem.name.toLowerCase()"
							[class.active]="isActiveRoute(navigationItem)"
							(click)="onNavigationClick(navigationItem)"
							(keyup.enter)="onNavigationClick(navigationItem)"
							(keyup.space)="onNavigationClick(navigationItem)"
							tabindex="0"
							[attr.aria-current]="isActiveRoute(navigationItem) ? 'page' : 'false'"
							[attr.aria-label]="navigationItem.translationKey | translate">
							<div class="navigation-item-name">{{ navigationItem.translationKey | translate }}</div>
						</a>
					</li>
				}
			</ul>
		</nav>
	</div>
</div>
